<template>
  <article id="closet-wrapper" class="contents-wrapper">
    <router-view />
  </article>
</template>

<script lang="ts">
export default {
  setup() {
    return {};
  },
  data() {
    return { title: "" };
  },
  methods: {},
  created() {
    console.log("[ClosetWrapper] created");
    window.scrollTo(0, 0);
  },
};
</script>

<style lang="scss" scoped></style>
